export default {
    hasSeenAllMessages    : state => state.hasSeenAllMessages
};
